<template>
  <el-form ref="form" :model="form" :rules="rules" label-position="top" :disabled="isView">
    <el-row>
      <el-col :span="11">
        <el-form-item label="企业最高管理者姓名" prop="headName" class="font-bold">
          <el-input v-model="form.headName" placeholder="请输入管理者姓名" />
        </el-form-item>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-form-item label="联系电话" prop="headPhone" class="font-bold">
          <el-input v-model="form.headPhone" placeholder="请输入联系电话" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="11">
        <el-form-item label="信息化部门负责人姓名" prop="headJob" class="font-bold">
          <el-input v-model="form.headJob" placeholder="请输入负责人姓名" />
        </el-form-item>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-form-item label="联系电话" prop="headJobPhone" class="font-bold">
          <el-input v-model="form.headJobPhone" placeholder="请输入联系电话" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item v-if="!isView">
      <el-button type="primary" @click="handleSave">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  props: ['info', 'isView'],
  data () {
    return {
      form: {},
      rules: {
        headName: [
          { required: true, message: '请输入管理者姓名', trigger: 'blur' }
        ],
        headJob: [
          { required: true, message: '请输入负责人姓名', trigger: 'blur' }
        ],
        headPhone: [
          { required: true, message: '联系电话不能为空' },
          {
            validator: (rule, value, callback) => {
              if (value && !/^1\d{10}$/.test(value)) {
                callback(new Error('请输入正确的联系电话'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        headJobPhone: [
          { required: true, message: '联系电话不能为空' },
          {
            validator: (rule, value, callback) => {
              if (value && !/^1\d{10}$/.test(value)) {
                callback(new Error('请输入正确的联系电话'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted () {
    this.form = {
      headName: this.info.headName,
      headJob: this.info.headJob,
      headPhone: this.info.headPhone,
      headJobPhone: this.info.headJobPhone
    }
  },
  methods: {
    handleSave () {
      this.$emit('save', this.form)
    }
  }
}
</script>
